/* eslint-disable no-await-in-loop */
import {
  Button,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  FormControl,
  Chip,
  Autocomplete,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Collapse,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogActions,
  useMediaQuery,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import PrintIcon from '@mui/icons-material/Print';
import { Container } from 'reactstrap';
import moment from 'moment';
import { useTheme } from '@emotion/react';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';
import NoResultsFound from '../../components/NoResultsFound';
import {
  showProgressToast,
  completeProgressToast,
  dismissProgressToast,
  updateProgressToast,
} from '../../components/Snackbar/toastHelpers';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  backgroundColor: '#47A992',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const filterInitialValue = {
  FromDate: moment().startOf('month').format('YYYY-MM-DD'),
  ToDate: moment().format('YYYY-MM-DD'),
  Buyer: { BuyerId: 0, Buyer: 'All Buyers' },
  Factory: { AccId: 0, AccName: 'All Factories' },
  Style: { StyleNo: 'All Styles' },
  InspectionType: { InspectionTypeId: 0, InspectionType: 'All Inspection Types' },
  Status: 0,
  Inspector: { UserId: 0, LoginName: 'All Inspectors' },
};

const Inspections = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [Inspections, setInspections] = useState([]);
  const [filterStyles, setFilterStyles] = useState([]);
  const [filterInspectors, setFilterInspectors] = useState([]);
  const [filterInspectionTypes, setFilterInspectionTypes] = useState([]);
  const [buyers, setBuyers] = useState([]);
  const [factories, setFactories] = useState([]);
  const [expanded, setExpanded] = useState(true);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [DeleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    getAllInspection();
    GetAllHelpData();
    setIsAdmin(sessionStorage.getItem('Designation')?.toLowerCase()?.trim() === 'admin');
  }, []);

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const resData = await axios.get('ReferenceData/GetAllBuyers');
      const resData1 = await axios.get('ReferenceData/GetAllFactories');
      const resData2 = await axios.post('Master/User/GetAllSupervisor', { UserId: sessionStorage.getItem('UserId') });
      const resData3 = await axios.get('Master/InspectionType/GetAllInspectionType');

      setBuyers(resData.data);
      setFactories(resData1.data);
      setFilterInspectors(resData2.data);
      setFilterInspectionTypes(resData3.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  async function getAllInspection() {
    try {
      showLoading();
      const response = await axios.post('Transaction/InspectionHeader/GetAllInspectionHeaders', {
        FromDate: moment(filterData.FromDate).format('YYYYMMDD'),
        ToDate: moment(filterData.ToDate).format('YYYYMMDD'),
        FactoryId: filterData.Factory.AccId,
        BuyerId: filterData.Buyer.BuyerId,
        StyleNo: filterData.Style.StyleNo === 'All Styles' ? 0 : filterData.Style.StyleNo,
        InspectorId: filterData.Inspector.UserId,
        InspectionTypeId: filterData.InspectionType.InspectionTypeId,
        Status: filterData.Status,
        UserId: sessionStorage.getItem('UserId'),
      });
      setInspections(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const handlePrintClick = (Inspection) => {
    const toastId = Date.now();
    showProgressToast(toastId, 'Downloading Inspection Report...', 0);
    getInspectionDetialPDF(Inspection, toastId);
  };

  const getInspectionDetialPDF = async (Inspection, toastId) => {
    let progress = 0;
    let progressInterval;
    let downloadCompleted = false;
    let lastUpdateTime = Date.now();
    const { InspectionCode, QAInspectionId } = Inspection;
    try {
      // Start continuous progress animation
      progressInterval = setInterval(() => {
        if (downloadCompleted) return;

        // Calculate time-based progress (about 1-2 minutes to reach 90%)
        const elapsed = (Date.now() - lastUpdateTime) / 1000; // in seconds
        const timeBasedProgress = Math.min(90, elapsed * 0.75); // ~90% in 120 seconds

        // Add some randomness to make it feel more natural
        const randomFactor = 1 + (Math.random() * 0.2 - 0.1); // ±10% variation
        progress = Math.min(90, timeBasedProgress * randomFactor);

        updateProgressToast(toastId, Math.floor(progress), `Processing Inspection Report ${InspectionCode}`);
      }, 300);

      const response = await axios.post(
        'Report/Inspection/InspectionReportPDF',
        { QAInspectionId, recipientEmail: sessionStorage.getItem('UserEmail') },
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const realProgress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
              // If we have real progress, use it but keep it above our animated progress
              progress = Math.max(progress, Math.min(realProgress, 99));
              lastUpdateTime = Date.now(); // Reset the timer when we get real progress
            }
          },
        }
      );

      // Download complete - finish the animation
      downloadCompleted = true;
      clearInterval(progressInterval);

      // Animate from current progress to 100%
      while (progress < 100) {
        progress = Math.min(progress + 2, 100);
        updateProgressToast(
          toastId,
          Math.floor(progress),
          `Finalizing Inspection Report ${InspectionCode}... (${Math.floor(progress)}%)`
        );
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      completeProgressToast(toastId, `Inspection Report ${InspectionCode} Downloaded & Copy has been Sent in Email!`);
      const fileName = `Inspection-${Inspection.Buyer}-${Inspection.Styleno.replace(`/${Inspection.Ipono}`, '')}-${
        Inspection.TypesofInspection
      }-${Inspection.InspectionCode}-${Inspection.QAInspectionDate}.pdf`
        .replace(/\s+/g, '')
        .replace(/\//g, '_');
      // Create and download the PDF
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
        link.remove();
        window.URL.revokeObjectURL(url);
      }, 200);
    } catch (e) {
      if (progressInterval) clearInterval(progressInterval);
      dismissProgressToast(toastId);

      const errorMsg = e.response?.data?.message || `Failed to download Inspection Report ${InspectionCode}`;

      openSnackBar(errorMsg, 'error');
    }
  };

  const DeleteInspection = async () => {
    try {
      showLoading();
      await axios.post('Transaction/InspectionHeader/DeleteInspectionDetails', { QAInspectionId: DeleteId });
      openSnackBar('Inspection Deleted Successfully !', 'success');
      handleCloseDelete();
      getAllInspection();
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const getStyleNo = async () => {
    try {
      if (!filterData.Buyer.BuyerId || !filterData.Factory.AccId) return;
      const response = await axios.post('ReferenceData/GetAllStyles', {
        FactoryId: filterData.Factory.AccId,
        BuyerId: filterData.Buyer.BuyerId,
      });
      setFilterData({ ...filterData, Style: { StyleNo: 'All Styles' } });
      setFilterStyles(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    // hideLoading();
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const handleInspectionPreviewClick = (QAInspectionId) => {
    navigate(`/transactions/Inspections/preview/${QAInspectionId}`);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  useEffect(() => {
    getStyleNo();
  }, [filterData.Buyer, filterData.Factory]);

  const filteredData = useMemo(() => {
    const newTableData = [...Inspections];
    if (page > 0) setPage(0);
    return newTableData;
  }, [Inspections, filterData]);

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [filteredData, page, rowsPerPage]);

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              INSPECTIONS
            </Typography>
          </Typography>
        </Grid>
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={() => {
              setExpanded((expand) => !expand);
            }}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="#8EACCD">
                  <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#8EACCD',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>
                <Grid item md={2} xs={12}>
                  {/* From Date */}
                  <TextField
                    fullWidth
                    label="From Date"
                    type="date"
                    name="fromDate"
                    value={filterData.FromDate}
                    onChange={(e) => {
                      handleFilterDataChange('FromDate', e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* To Date */}
                  <TextField
                    fullWidth
                    label="To Date"
                    type="date"
                    name="ToDate"
                    value={filterData.ToDate}
                    onChange={(e) => {
                      handleFilterDataChange('ToDate', e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{ AccId: 0, AccName: 'All Factories' }, ...factories]}
                    getOptionLabel={(factory) => factory.AccName}
                    isOptionEqualToValue={(value) => value.AccId === filterData.Factory.AccId}
                    renderOption={(props, factory) => (
                      <li {...props} key={factory.AccId}>
                        {factory.AccName}
                      </li>
                    )}
                    value={filterData.Factory || null}
                    name="Factory"
                    onChange={(event, value) => {
                      handleFilterDataChange('Factory', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Factory" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{ BuyerId: 0, Buyer: 'All Buyers' }, ...buyers]}
                    getOptionLabel={(buyers) => buyers.Buyer}
                    isOptionEqualToValue={(value) => value.BuyerId === filterData.Buyer?.BuyerId}
                    renderOption={(props, buyers) => (
                      <li {...props} key={buyers.BuyerId}>
                        {buyers.Buyer}
                      </li>
                    )}
                    value={filterData.Buyer}
                    name="Buyer"
                    onChange={(event, value) => {
                      handleFilterDataChange('Buyer', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Buyer" />}
                  />
                </Grid>

                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={[{ StyleNo: 'All Styles' }, ...filterStyles]}
                    getOptionLabel={(styles) => styles.StyleNo}
                    isOptionEqualToValue={(value) => value.StyleNo === filterData.Style.StyleNo}
                    renderOption={(props, styles) => (
                      <li {...props} key={styles.StyleNo}>
                        {styles.StyleNo}
                      </li>
                    )}
                    value={filterData.Style || null}
                    name="Style"
                    onChange={(event, value) => {
                      handleFilterDataChange('Style', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Style No" />}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={[{ UserId: 0, LoginName: 'All Inspector' }, ...filterInspectors]}
                    getOptionLabel={(inspector) => inspector.LoginName}
                    isOptionEqualToValue={(value) => value.UserId === filterData.Inspector.UserId}
                    renderOption={(props, user) => (
                      <li {...props} key={user.UserId}>
                        {user.LoginName} {user.Designation ? ` ( ${user.Designation} ) ` : ''}
                      </li>
                    )}
                    value={filterData.Inspector || null}
                    name="Inspector"
                    onChange={(event, value) => {
                      handleFilterDataChange('Inspector', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Inspector" />}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={[
                      { InspectionTypeId: 0, InspectionType: 'All Inspection Types' },
                      ...filterInspectionTypes,
                    ]}
                    getOptionLabel={(inspection) => inspection.InspectionType}
                    isOptionEqualToValue={(value) =>
                      value.InspectionTypeId === filterData.InspectionType.InspectionTypeId
                    }
                    renderOption={(props, inspection) => (
                      <li {...props} key={inspection.InspectionTypeId}>
                        {inspection.InspectionType}
                      </li>
                    )}
                    value={filterData.InspectionType || null}
                    name="InspectionType"
                    onChange={(event, value) => {
                      handleFilterDataChange('InspectionType', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Inspection Type" />}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={filterData.Status}
                      name="Status"
                      size="small"
                      label="Status"
                      onChange={(event) => {
                        handleFilterDataChange('Status', event.target.value);
                      }}
                    >
                      {[
                        { value: '0', label: 'All Status' },
                        { value: 'P', label: 'Pass' },
                        { value: 'F', label: 'Fail' },
                        { value: 'H', label: 'Hold' },
                      ].map((option, i) => (
                        <MenuItem key={option.label} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={1} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => {
                      getAllInspection();
                    }}
                    sx={{ boxShadow: 0 }}
                  >
                    View
                  </Button>

                  {/* View Button */}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Stack>
        <Collapse in={filteredData.length > 0}>
          <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
            <Table className="table-bordered" size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">InspNo</StyledTableCell>
                  <StyledTableCell align="left">Date</StyledTableCell>
                  <StyledTableCell align="left">Factory</StyledTableCell>
                  <StyledTableCell align="left">Buyer</StyledTableCell>
                  <StyledTableCell align="left">Style</StyledTableCell>
                  <StyledTableCell align="left">Po No</StyledTableCell>
                  <StyledTableCell align="left">Shipment Qty</StyledTableCell>
                  <StyledTableCell align="left">Inspection Type</StyledTableCell>
                  <StyledTableCell align="left">Status</StyledTableCell>
                  <StyledTableCell align="left">Total Defect</StyledTableCell>
                  <StyledTableCell align="left">Auditor</StyledTableCell>
                  <StyledTableCell align="center">Actions</StyledTableCell>
                  {/* <StyledTableCell align="center">Print</StyledTableCell> */}
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : filteredData
                ).map((Inspection) => (
                  <TableRow key={Inspection.InspectionCode} hover>
                    <TableCell align="center">{Inspection.InspectionCode}</TableCell>
                    <TableCell align="left">{Inspection.QAInspectionDate}</TableCell>
                    <TableCell align="left">{Inspection.Factory}</TableCell>
                    <TableCell align="left">{Inspection.Buyer}</TableCell>
                    <TableCell align="left">{Inspection.Styleno}</TableCell>
                    <TableCell align="left">{Inspection.Pono?.split(',').join(', ')}</TableCell>
                    <TableCell align="left">{Inspection.Shipqty}</TableCell>
                    <TableCell align="left">{Inspection.InspectionType}</TableCell>
                    <TableCell align="center">
                      <Chip
                        color={
                          Inspection.Status?.trim() === 'P'
                            ? 'success'
                            : Inspection.Status?.trim() === 'F'
                            ? 'error'
                            : 'warning'
                        }
                        label={
                          Inspection.Status?.trim() === 'P'
                            ? 'Pass'
                            : Inspection.Status?.trim() === 'F'
                            ? 'Fail'
                            : 'Hold'
                        }
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell align="left">{Inspection.TotalDefect}</TableCell>
                    <TableCell align="left">{Inspection.Auditor}</TableCell>
                    <TableCell align="center">
                      <Stack direction="row">
                        <IconButton
                          aria-label="print-inspection-report"
                          onClick={() => {
                            handleInspectionPreviewClick(Inspection.QAInspectionId, Inspection.InspectionCode);
                          }}
                          title="View Inspection"
                        >
                          <RemoveRedEyeIcon color="primary" />
                        </IconButton>
                        <IconButton
                          aria-label="print-inspection-report"
                          onClick={() => {
                            handlePrintClick(Inspection);
                          }}
                          title=" Inspection Detail PDF"
                        >
                          <PrintIcon color="primary" />
                        </IconButton>
                        {isAdmin && (
                          <IconButton
                            aria-label="Delete"
                            onClick={() => {
                              setDeleteId(Inspection.QAInspectionId);
                              setOpenDelete(true);
                            }}
                          >
                            <DeleteForeverIcon color="error" />
                          </IconButton>
                        )}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
                {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )} */}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRows}
            rowsPerPage={rowsPerPage}
            page={currentPage} // Use the calculated currentPage value
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0); // Reset the page when rowsPerPage changes
            }}
            mt={2}
          />
        </Collapse>
        {!filteredData.length > 0 && <NoResultsFound />}
      </Container>
      <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
        <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={DeleteInspection} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Inspections;
